<template>
  <form class="signup-form" @submit.prevent="emitSubmit">
    <div style="display: flex; align-items: center; gap: 12px; justify-content: center;">
      <p style="text-align: center; margin-bottom: 0px; padding-bottom: 0px; margin-top: 5px; padding-top: 0px; flex: 1; font-size: 0.85rem; -webkit-text-size-adjust: 100%; text-size-adjust: 100%;">No app to download.<br>Try it free below.</p>
    </div>
    <div class="form-field">
      <label for="name">Name</label>
      <input type="text" id="name" v-model="localForm.name" required 
             maxlength="100"
             pattern="^[a-zA-Z \-']+$"
             title="Name can only contain letters, spaces, hyphens, and apostrophes" />
    </div>
    <div class="form-field">
      <label for="email">Email</label>
      <input type="email" id="email" v-model="localForm.email" required 
             maxlength="254" />
    </div>
    <div class="consent-row" :class="{ 'consent-error': consentError }">
      <label for="consent" class="consent-label">
        <input type="checkbox" id="consent" v-model="consentGiven" class="consent-checkbox" />
        I agree to the
        <router-link to="/terms" style="color: #7da47e; text-decoration: none; cursor: pointer;">Terms</router-link>
        and <router-link to="/privacy-policy" style="color: #7da47e; text-decoration: none; cursor: pointer;">Privacy Policy</router-link>.
      </label>
      <p v-if="consentError" class="consent-error-message">Check this box if you have read and agree to the Terms and Privacy Policy.</p>
    </div>

    <button type="submit" :disabled="isLoading">
      <span v-if="!isLoading">Get Started</span>
      <span v-else class="spinner"></span>
    </button>

    <div style="display: flex; align-items: center; gap: 12px; justify-content: center;">
      <p style="text-align: center; margin-bottom: 0px; padding-bottom: 0px; margin-top: 15px; padding-top: 0px; flex: 1; font-size: 0.85rem; -webkit-text-size-adjust: 100%; text-size-adjust: 100%;">Email free forever.<br>Switch to texts for $5/month.</p>
    </div>

    
  </form>
</template>

<script>
export default {
  name: 'SignupForm',
  props: {
    form: { type: Object, required: true },
    isLoading: { type: Boolean, default: false }
  },
  emits: ['submit', 'show-login'],
  data() {
    return {
      localForm: { ...this.form },
      consentGiven: false,
      consentError: false
    };
  },
  watch: {
    form: {
      handler(newVal) {
        this.localForm = { ...newVal };
      },
      deep: true
    },
    consentGiven(val) {
      if (val) this.consentError = false;
    }
  },
  methods: {
    emitSubmit() {
      if (!this.consentGiven) {
        this.consentError = true;
        return;
      }
      this.$emit('submit', { ...this.localForm });
    }
  }
};
</script>

<style scoped>
.signup-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-top: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #fff;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
}
.signup-form h3 {
  font-family: 'LemonCupcakeBold', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-size: 2rem;
  font-weight: 300;
  letter-spacing: 0.01em;
  color: #312d30;
  margin-top: 0;
  margin-bottom: 16px;
  text-align: center;
}
.signup-form div {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.signup-form .form-field {
  flex-direction: column;
  align-items: flex-start;
}
.signup-form .form-field label {
  margin-right: 0;
  margin-bottom: 4px;
  font-size: 1rem;
  font-weight: normal;
}
.consent-row {
  display: block !important;
  text-align: left;
  margin-top: -6px;
  margin-bottom: 5px;
  border-radius: 6px;
}
.consent-row.consent-error {
  animation: consent-shake 0.4s;
}
.consent-error-message {
  color: #c0392b;
  font-size: 0.8rem;
  font-weight: 500;
  margin: 4px 0 0 0;
}
@keyframes consent-shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
}
.consent-checkbox {
  width: auto !important;
  margin-left: 0;
  margin-right: 4px;
  vertical-align: middle;
  cursor: pointer;
  background-color: #f5f5f5;
}
.consent-label {
  display: inline !important;
  min-width: 0 !important;
  margin-right: 0 !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  color: #312d30;
  cursor: pointer;
  text-align: left !important;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
.signup-form label {
  display: inline-block;
  min-width: 70px;
  margin-bottom: 0;
  margin-right: 10px;
  font-weight: bold;
  color: #312d30;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
}
.signup-form label[for="name"],
.signup-form label[for="email"],
.signup-form label[for="phone"] {
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
}
.signup-form input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f5f5f5;
  flex: 1;
  box-sizing: border-box;
  font-size: 16px; /* Use 16px for minimum mobile font size to prevent zoom */
}
.signup-form button,
.login-btn,
.top-login-link {
  font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif !important;
  font-size: 1.13rem;
  font-weight: bold;
}
.signup-form button {
  background: #7da47e;
  color: #fff;
  border: none;
  padding: 8px 32px;
  border-radius: 4px;
  cursor: pointer;
  align-self: center;
  margin-top: 10px;
  min-width: 120px;
  width: auto;
  white-space: nowrap;
}
.signup-form button[disabled] {
  background: #ccc !important;
  color: #fff !important;
  cursor: not-allowed;
  opacity: 0.7;
  pointer-events: none;
}
.signup-form button:hover {
  background: #388E3C;
}
.login-under-signup {
  margin-top: 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-prompt {
  margin: 0 0 8px 0;
  color: #312d30;
  font-size: 1.75rem;
  font-family: 'LemonCupcakeBold', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-weight: 300;
  letter-spacing: 0.01em;
}
.login-btn-block {
  display: block;
  width: fit-content;
  margin: 8px auto 0 auto;
}
.signup-form-info {
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
  font-size: 1.08rem;
  font-weight: 600;
  color: #312d30;
  letter-spacing: 0.01em;
  line-height: 1.85;
  margin-bottom: 18px;
  text-align: left;
  max-width: 540px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  word-break: break-word;
}
.beta-message {
  font-style: italic;
  color: #7da47e;
  margin-top: 0;
  margin-bottom: 16px;
  text-align: center;
}
.signup-form, .signup-form label, .signup-form input, .signup-form button
{
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
}
@media (max-width: 700px) {
  .signup-form {
    width: 100%;
    max-width: none;
    box-sizing: border-box;
  }
  .signup-form div {
    width: 100%;
    justify-content: center;
  }
  .signup-form div[style*="display: flex"][style*="align-items: center"] {
    flex-direction: column !important;
    gap: 8px !important;
  }
  .signup-form label, .signup-form input {
    text-align: left;
  }
  .signup-form button {
    align-self: center;
  }
  .signup-form h3 {
    text-align: center;
    width: 100%;
  }
}
@media (max-width: 400px) {
  .signup-form label {
    min-width: 50px;
    font-size: 0.95em;
  }
  .signup-form input {
    font-size: 16px; /* Ensure 16px minimum on small screens too */
  }
  .signup-form h3 {
    font-size: 1.1em;
  }
}
/* Small phones (e.g. iPhone SE) need tighter side padding so text has more room */
@media (max-width: 380px) {
  .signup-form {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
